import * as d3 from 'd3'
// let pymChild
/// Read google spreadsheet/////

// const ledeText = d3.select('#kentucky-text-lede')
const graf1Text = d3.select('#kentucky-text-graf1')
const graf2Text = d3.select('#kentucky-text-graf2')
const graf3Text = d3.select('#kentucky-text-graf3')
const graf4Text = d3.select('#kentucky-text-graf4')
// const graf5Text = d3.select('#kentucky-text-graf5')
// const graf6Text = d3.select('#kentucky-text-graf6')
// const graf7Text = d3.select('#kentucky-text-graf7')
// const graf8Text = d3.select('#kentucky-text-graf8')
// const graf9Text = d3.select('#kentucky-text-graf9')
// const graf10Text = d3.select('#kentucky-text-graf10')

const parseDate = d3.timeParse('%Y-%m-%d')
const formatTime = d3.timeFormat('%b %d')
const commaFormat = d3.format(',')

Promise.all([
  d3.csv(
    'https://raw.githubusercontent.com/louisvillepublicmedia/COVID-Data/main/vaccine-data-ohio-valley%20-%20Sheet1.csv'
  ),
  d3.csv(
    'https://raw.githubusercontent.com/louisvillepublicmedia/COVID-Data/main/vaccination-timeseries-ohio-valley%20-%20Sheet1.csv'
  )
])
  .then(ready)
  .catch(err => console.log('Failed on', err))

function ready([data, timeData]) {
  // console.log(data)

  data = data.filter(function(d, i) {
    return (d.state_abbreviation === 'KY') & (i === 0)
  })

  timeData = timeData.filter(function(d, i) {
    return d.state_postal === 'KY'
  })

  timeData = timeData.filter(function(d, i) {
    return i === 0
  })


  console.log(timeData)

  graf1Text
    .selectAll('.graf')
    .data(data)
    .join('div')
    .attr('class', 'graf')
    .html(function(d) {
      d.datetime = parseDate(d.date)
      return `<p>As of ${formatTime(
        d.datetime
      )}, ${d.state_name} received <span style='background-color:pink;padding-left:4px;padding-right:4px;padding-bottom:3px;color:black;'>${commaFormat(d.doses_distributed_cumulative)} doses</span> from the federal government. It had used <span style='background-color:pink;padding-left:4px;padding-right:4px;padding-bottom:3px;color:black;'>${commaFormat(d.doses_administered_cumulative)} doses, or ${d.percent_doses_administered}% </span> of its supply. The state targets to administer 90% of all vaccines received within 7 days of arrival.</p>`
    })
    .style('position', 'relative')

  graf2Text
    .selectAll('.graf')
    .data(data)
    .join('div')
    .attr('class', 'graf')
    .html(function(d) {
      d.datetime = parseDate(d.date)
      return `<p>The state government faces two challenges: securing an adequate supply of vaccines and administering those doses rapidly. The chart below keeps track of new doses administered by day. The bars provide daily information while the lines represent the weekly trends. On ${formatTime(
        d.datetime
      )}, the state administered <span style='background-color:pink;padding-left:4px;padding-right:4px;padding-bottom:3px;color:black;'>${commaFormat(d.new_doses_administered)} new doses</span> of COVID-19 vaccine.</p>`
    })
    .style('position', 'relative')

  graf3Text
    .selectAll('.graf')
    .data(data)
    .join('div')
    .attr('class', 'graf')
    .html(function(d) {
      d.datetime = parseDate(d.date)
      return `<p>Under ${d.state_name}'s vaccination plan, the state will administer doses in multiple phases. In Phase 1, the state will vaccinate people in long-term care facilities, assisted living facilities, first responders, essential workers and anyone age 60 or older or with high-risk health conditions. In Phase 2 and Phase 3, the state will give doses to anyone older than 16 years. In Phase 4, the state will administer doses to children below 16 years if the vaccine is approved for that population group.
      </p>`
    })
    .style('position', 'relative')

  graf4Text
    .selectAll('.graf')
    .data(timeData)
    .join('div')
    .attr('class', 'graf')
    .html(function(d) {
      d.datetime = parseDate(d.date)
      return `<p>The state reported that <span style='background-color:pink;padding-left:4px;padding-right:4px;padding-bottom:3px;color:black;'>${d.percent_first_dose_administered}% of its population got at least one dose of the vaccine, while ${d.percent_fully_vaccinated}% has been fully vaccinated</span>.</p>`
    })
    .style('position', 'relative')

  // graf5Text
  //   .selectAll('.graf')
  //   .data(graf5)
  //   .join('div')
  //   .attr('class', 'graf')
  //   .html(d => `<p>${d.text}</p>`)
  //   .style('position', 'relative')

  // graf6Text
  //   .selectAll('.graf')
  //   .data(graf6)
  //   .join('div')
  //   .attr('class', 'graf')
  //   .html(d => `<p>${d.text}</p>`)
  //   .style('position', 'relative')

  // graf7Text
  //   .selectAll('.graf')
  //   .data(graf7)
  //   .join('div')
  //   .attr('class', 'graf')
  //   .html(d => `<p>${d.text}</p>`)
  //   .style('position', 'relative')

  // graf8Text
  //   .selectAll('.graf')
  //   .data(graf8)
  //   .join('div')
  //   .attr('class', 'graf')
  //   .html(d => `<p>${d.text}</p>`)
  //   .style('position', 'relative')

  // graf9Text
  //   .selectAll('.graf-source')
  //   .data(graf9)
  //   .join('div')
  //   .attr('class', 'graf-source')
  //   .html(
  //     d =>
  //       `<p><span style='font-size:18px; font-weight:bold;text-decoration:underline;'>Data sources</span></br><span style='font-size:14px;'>${d.text}</span></p>`
  //   )
  //   .style('position', 'relative')

  // graf10Text
  //   .selectAll('.graf-source')
  //   .data(graf10)
  //   .join('div')
  //   .attr('class', 'graf-source')
  //   .html(
  //     d =>
  //       `<p><span style='font-size:18px; font-weight:bold;text-decoration:underline;'>Recommendations and resources</span></br><span style='font-size:14px;'>${d.text}</span></p>`
  //   )
  //   .style('position', 'relative')
}
